<template>
    <div id="app" class="container-fluid px-0 d-flex w-100 vh-100 p-0 m-0 overflow-hidden">
        <nav class="d-flex flex-shrink-0 z-2">
            <SidebarNav />
        </nav>
        <main class="z-2 d-flex container-fluid p-0">
            <div class="content m-0 p-0 bg-dark container-fluid d-flex flex-column vh-100"><!-- container -->
                <!-- <div class="p-3 z-2">
                        <button class="btn btn-primary w-100" @click="show()">toast</button>
                </div> -->
                <header class="p-3 z-2">
                    <div class="d-flex w-100 w-sm-50 justify-content-center">
                        <img class="img-fluid logo" v-bind:src="$glob.logoBanner" v-bind:alt="$glob.companyShortName + ' Logo'"/> 
                    </div>
                </header>
                <content class="p-3 z-2 flex-grow-1 overflow-y-auto">
                    <div class="">
                        <div class="mb-3 mt-3">
                            <router-view id="view"/>
                        </div>
                    </div>
                </content><!-- content -->
                <footer class="footer z-0 sticky-bottom"><!-- footer -->
                    <div class="copyright">Copyright &copy; 2024-{{ currentYear }}&nbsp;<strong><span>{{$company.fullName}}</span></strong>. All Rights Reserved</div>
                </footer><!-- end footer -->
            </div><!-- end container -->
        </main>
    </div><!-- end app -->
    <a href="#" class="back-to-top"><i class="bi bi-arrow-up-short"></i></a>
    <!-- <div class="tooltip bs-tooltip-top" role="tooltip">
        <div class="arrow"></div>
        <div class="tooltip-inner">
            Some tooltip text!
        </div>
    </div> -->
</template>

<script>
import SidebarNav from './components/SidebarNav.vue'

export default {
    methods: {
        show() {
            try {
                console.log('Toast Method Fired');
            } catch (error) {
                console.error('Unable to show toast',error);
            }
        }
    },
    components: {
        SidebarNav,
    },
    data() {
        return {
            currentYear: new Date().getFullYear(),
        }
    },
}
</script>
